import { ModalShell } from './ModalShell.js';
import { pillButton } from './pillButton.js';

import type { ReactElement } from 'react';

type LeaveModalProps = {
  readonly partyDisplayName: string;
  readonly isPending: boolean;
  readonly onLeave: () => void;
  readonly onEndParty: () => void;
  readonly onCancel: () => void;
};

/**
 * Stepping off and calling the night over are one button because they are one
 * moment — a DJ deciding they are finished — and two buttons side by side in a
 * header is how the second one gets pressed by accident.
 */
export const LeaveModal = ({
  partyDisplayName,
  isPending,
  onLeave,
  onEndParty,
  onCancel,
}: LeaveModalProps): ReactElement => (
  <ModalShell title={`Leaving ${partyDisplayName}`} onDismiss={onCancel}>
    <p className="text-secondary mt-2 text-sm">
      Stepping off frees your channel for someone else and leaves the party running.
    </p>
    <div className="mt-4 flex flex-col gap-2">
      <button type="button" disabled={isPending} onClick={onLeave} className={pillButton('solid')}>
        Leave the party
      </button>
      <button
        type="button"
        disabled={isPending}
        onClick={onEndParty}
        className={pillButton('quiet-danger')}
      >
        End the party for everyone
      </button>
      <button type="button" onClick={onCancel} className={pillButton('ghost')}>
        Cancel
      </button>
    </div>
  </ModalShell>
);
